import { useEffect } from 'react';
import { ControllerFieldState } from 'react-hook-form';
import { AcceptsSetFormItemError } from 'src/components/Form/FormItem/FormItem';

export default function useFormItemError(
    props: AcceptsSetFormItemError,
    fieldState: ControllerFieldState,
) {
    useEffect(() => {
        if (props?.setFormItemError) {
            props.setFormItemError(fieldState?.error?.message);
        }
    }, [fieldState.error]);
}
